import { pageTitles } from '@shared/enums/pageTitles';
import { useTitle } from '@shared/hooks/useTitle';
import { AsyncData } from '@shared/interfaces/asyncData';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LocationOptionData } from '@shared/interfaces/LocationOptionData';
import { getAllLocationsData } from '../redux/actions';
import { getAllFlagsDataSelector, getAllLocationsDataSelector, selectLocations } from '../redux/selectors';
import { AllFlagsPageData } from '../interfaces/AllFlagsPageData';
import { sortLocationOptions } from '@shared/helpers/sortLocationOptions';

export const useAllFlagsData = (): {
  allFlags: AsyncData<AllFlagsPageData>;
  locationOptions: LocationOptionData[];
} => {
  const dispatch = useDispatch();
  const allFlags = useSelector(getAllFlagsDataSelector);
  const locations = useSelector(getAllLocationsDataSelector);
  const [locationOptions, setLocationOptions] = useState<LocationOptionData[]>(useSelector(selectLocations) ?? []);
  const setPageTitle = useTitle();

  useEffect(() => {
    setPageTitle(pageTitles.allFlags);
  }, []);

  useEffect(() => {
    dispatch(getAllLocationsData());
  }, []);

  useEffect(() => {
    if (locations.data) {
      setLocationOptions(sortLocationOptions(locations.data));
    }
  }, [locations.data]);

  return { allFlags, locationOptions };
};
